import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import { GetCountry } from "@/api/Api";
import { ToastContainer, toast } from "react-toastify";
import InputLabel from "@mui/material/InputLabel";
import DatePicker from "../DatePicker/DatePicker";
import { Select, MenuItem } from "@mui/material";

const CustomInput = ({
  label,
  name,
  onBlur,
  value,
  handleChange,
  error,
  touched,
  helperText,
  country,
  disablePast,
  placeholder,
  required,
  ...rest
}) => {
  // const isRequiredField = [
  //   "FirstName",
  //   "LastName",
  //   "EmailId",
  //   "quantityneeded",
  //   "Detailsofcustomchemicalrequirements",
  //   "Detailsofsampleneeded",
  //   "CompanyName",
  //   "Tentativerequistiondate",
  //   "Requisitioncountry",
  //   "NameofProduct",
  //   "address1",
  //   "postalCode",
  // ].includes(name);
  const isDatePickerField = label === "Tentative requisition date";
  const isSelectField = label === "Requisition country";

  return (
    <div>
      <label
        htmlFor={name}
        style={{
          fontSize: "16px",
        }}
      >
        {label} {required && <span style={{ color: "red" }}>*</span>}
      </label>

      {isDatePickerField ? (
        <DatePicker
          {...rest}
          disablePast={disablePast}
          placeholder={placeholder}
          onChange={(value) =>
            handleChange({
              target: {
                value: value,
                name: name,
              },
            })
          }
          value={value || null}
          name={name}
          // error={console.log(error && touched,"jjbejbe")}
          sx={{
            ".MuiInputLabel-root.MuiInputLabel-formControl": {
              color: "#8080805",
            },
            "& .MuiInputBase-input": {
              fontStyle: "lowercase", // Add this line to set the font size
              color: "0000009e",
            },
          }}
        />
      ) : isSelectField ? (
        <Select
          id={name}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: "200px",
              },
            },
          }}
          displayEmpty
          renderValue={
            placeholder
              ? undefined
              : () => (
                  <span
                    style={{
                      color: "#8080805e",
                      fontStyle: "normal",
                    }}
                  >
                    {" "}
                    Select Country
                  </span>
                )
          }
          onChange={handleChange}
          value={value}
          name={name}
          onBlur={onBlur}
          error={error && touched}
          helperText={error && touched ? helperText : ""}
          sx={{ width: "100%" }}
        >
          <MenuItem value={""}>
            <em style={{ color: "#8080805e", fontStyle: "normal" }}>
              Select Country
            </em>
          </MenuItem>
          {country?.map((items) => (
            <MenuItem key={items?.name} value={items?.name}>
              {items?.name}
            </MenuItem>
          ))}
        </Select>
      ) : (
        <TextField
          placeholder={placeholder}
          type={label === "Quantity needed" ? "number" : "text"}
          sx={{
            width: "100%",
            paddingTop: "5px",
            marginTop: "-2px",
            input: {
              fontWeight: "normal",
            },
            "& .MuiOutlinedInput-root": {
              "&.Mui-focused fieldset": {
                borderColor: "#B3B3B3",
              },
            },
            "& .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary":
              {
                borderRadius: { xs: "5px !important", lg: "5px !important" },
              },
          }}
          InputProps={{
            style: {
              borderRadius: "10px",
              fontSize: "16px",
              fontWeight: "normal",
              fontFamily: "var(--font-mukta), sans-serif",
            },
          }}
          name={name}
          onBlur={onBlur}
          value={value}
          onChange={handleChange}
          error={error && touched}
          helperText={error && touched ? helperText : ""}
          disabled={label === "Name of product" && value ? true : false}
        />
      )}
    </div>
  );
};

export default CustomInput;
